import React from 'react';
import { useModalDismiss } from '../hooks/useModalDismiss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes, faCalendarAlt, faUser } from '@fortawesome/free-solid-svg-icons';

const AssignmentConflictModal = ({ isOpen, onClose, conflict, onAdjustPeriod }) => {
  const dismiss = useModalDismiss(onClose, { enabled: isOpen && !!conflict });

  if (!isOpen || !conflict) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          {...dismiss}
        ></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 text-xl" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                  Conflit d'assignation
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500 mb-4">
                    Ce poste est déjà assigné pendant la période sélectionnée.
                  </p>
                  
                  {/* Conflict Details */}
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                    <div className="space-y-2">
                      <div className="flex items-start">
                        <FontAwesomeIcon icon={faUser} className="text-red-600 mr-2 mt-1" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">Enquêteur assigné:</p>
                          <p className="text-sm text-gray-700">{conflict.interviewer_name}</p>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <FontAwesomeIcon icon={faCalendarAlt} className="text-red-600 mr-2 mt-1" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">Période d'assignation:</p>
                          <p className="text-sm text-gray-700">
                            Du {conflict.starts_at_formatted} au {conflict.ends_at_formatted}
                          </p>
                        </div>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-gray-900">Poste:</p>
                        <p className="text-sm text-gray-700">Poste {conflict.post_number}</p>
                      </div>
                    </div>
                  </div>

                  <p className="text-sm text-gray-600">
                    Veuillez ajuster la période d'assignation pour éviter le conflit.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={onAdjustPeriod}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Ajuster la période
            </button>
            <button
              type="button"
              onClick={onClose}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentConflictModal;

